module.exports = __webpack_public_path__ + "img/image(3).6ec65d0f.png";